<template>
  <span class="rt-breadcrumb__item">
    <span
      ref="link"
      :class="['rt-breadcrumb__inner', to ? 'is-link' : '']"
      role="link"
      @click="onItemClick()"
    >
      <rt-icon
        v-if="prevIconName"
        :name="prevIconName"
        size="16"
      />
      <slot></slot>
    </span>
    <div class="rt-breadcrumb__separator">
      <rt-icon :name="splitIconName"></rt-icon>
    </div>
    <!-- <span class="rt-breadcrumb__separator" role="presentation">{{separator}}</span> -->
  </span>
</template>
<script>
export default {
  name: 'RtBreadcrumbItem',
  props: {
    index: Number || String,
    prevIconName: String,
    // eslint-disable-next-line
    to: {},
    replace: Boolean,
    splitIconName: {
      type: String,
      default: 'rt-base-slash-lined'
    }
  },
  data () {
    return {
      separator: '',
      separatorClass: ''
    };
  },

  inject: ['rtBreadcrumb'],

  mounted () {
    this.separator = this.rtBreadcrumb.separator;
    this.separatorClass = this.rtBreadcrumb.separatorClass;
    const link = this.$refs.link;
    link.setAttribute('role', 'link');

    const fn = _ => {
      const { to, $router } = this;
      if (!to || !$router) return;
      this.replace ? $router.replace(to) : $router.push(to);
    };
    link.addEventListener('click', fn);

    this.$once('hook:beforeDestroy', () => {
      link.removeEventListener('click', fn);
    });
  },
  methods: {
    onItemClick () {
      this.$emit('on-breadcrumb-click', this.index);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtBreadcrumbItem.vue?293b824e